export const DsfCalculator = dsf.defineAsyncComponent('DsfCalculator', () => import(/*webpackChunkName: "platform_pc_calculator"*/'./calculator.vue'))